export default __webpack_public_path__ + "static/media/system-architecture.png";